export const listConstant = {
  childHeader: 'TOOL PREVENTIVE MAINTENANCE Plan list',
  addButtonLable: 'New Plan',
  datePickerLabel: 'Search By Year',
  modalTile: 'CREATE NEW PLAN',
};

export const createConstant = {
  childHeader: 'TOOL PREVENTIVE MAINTENANCE Plan list',
  theadHeader: 'TOOL PREVENTIVE MAINTENANCE Plan for the Machines for the Year',
  extracolSpan: 2,
};

export const checkListList = {
  childHeader: 'PREVENTIVE STATUS',
  addButtonLable: '',
  datePickerLabel: 'Search By Year',
  modalTile: 'UPDATE STATUS',
};

export const apiConstant = {
  deleteurl: 'toolPreventiveMaintenancePlanRoute',
  gettableDataurl: 'toolPreventiveMaintenancePlanRoute/monthly',
  getPlanByid: 'toolPreventiveMaintenancePlanRoute',
  createPlanByid: 'toolPreventiveMaintenancePlanRoute',
  updatePlanByid: 'toolPreventiveMaintenancePlanRoute',
  sync: 'toolPreventiveMaintenancePlanRoute/handleSync',
  getAllCheckList: 'toolPreventiveMaintenancePlanRoute/getAllCheckList',
  checkListStatus: 'toolPreventiveMaintenancePlanRoute/handleStatus',
  checklistUpload: 'toolPreventiveMaintenancePlanRoute/handleUpload',
  checklistDeleteImage: 'toolPreventiveMaintenancePlanRoute/handleDeleteImage',
  checklistData: 'toolPreventiveMaintenancePlanRoute/checklistRoute',
};

export const tilesConstant = {
  childHeaderText: 'Tool PREVENTIVE MAINTENANCE PLAN',
};

export const navigationConstant = {
  createPlanSchedule: '/common/toolPreventiveMaintenancePlanCreate',
  createChecklist: '/common/toolPreventiveMaintenancePlanChecklistCreate',
};
